"use strict";

const SALES_COMPLETED_STATUS_KEYS = new Set([
  "termine",
  "complete",
  "completed",
]);

const SALES_DELIVERED_STATUS_KEYS = new Set(["livre", "delivered"]);

const SALES_COMPLETED_STATUS_SQL_VALUES = Object.freeze([
  "terminé",
  "termine",
  "complété",
  "complete",
  "completed",
]);

const SALES_RETURN_ELIGIBLE_STATUS_SQL_VALUES = Object.freeze([
  ...SALES_COMPLETED_STATUS_SQL_VALUES,
  "livré",
  "livre",
  "delivered",
]);

const normalizeSalesReturnStatus = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const isSaleCompletedStatus = (value) =>
  SALES_COMPLETED_STATUS_KEYS.has(normalizeSalesReturnStatus(value));

const isSaleEligibleForReturnStatus = (value) => {
  const normalizedStatus = normalizeSalesReturnStatus(value);
  return (
    SALES_COMPLETED_STATUS_KEYS.has(normalizedStatus) ||
    SALES_DELIVERED_STATUS_KEYS.has(normalizedStatus)
  );
};

module.exports = {
  SALES_COMPLETED_STATUS_SQL_VALUES,
  SALES_RETURN_ELIGIBLE_STATUS_SQL_VALUES,
  isSaleCompletedStatus,
  isSaleEligibleForReturnStatus,
  normalizeSalesReturnStatus,
};
